@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">CRM</div>
        </div>
      </div>
    </div>
    <ul ngbNav #t="ngbNav" class="nav-tabs" (navChange)="alterarAbas($event)" [(activeId)]="tabSelecionada">
      <!-- Negócios -->
      <li [ngbNavItem]="'negocios'">
        <a ngbNavLink>
          <b>Negócios</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <app-crm-negocios></app-crm-negocios>
          </div>
        </ng-template>
      </li>
      <!-- Tarefas -->
      <li [ngbNavItem]="'tarefas'">
        <a ngbNavLink>
          <b>Tarefas</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <app-crm-tarefas></app-crm-tarefas>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="t"></div>
  </div>
}
